import React from 'react';
import {DropdownIndicatorProps, GroupBase, StylesConfig} from 'react-select';
import {SearchDropdownIndicator} from '../SearchDropdownIndicator';

/**
 * Shared styles for typeahead select components
 */
export function getTypeaheadStyles<
  Option,
  IsMulti extends boolean = false,
  Group extends GroupBase<Option> = GroupBase<Option>,
>(): StylesConfig<Option, IsMulti, Group> {
  return {
    control: (provided, state) => ({
      ...provided,
      border: '1px solid #EBE8EA',
      borderRadius: '10px',
      cursor: 'text',
      padding: '0px',
      margin: '0px',
      fontSize: '16px',
      flexDirection: state.hasValue ? 'row' : 'row-reverse',
      height: '58px',
      fontWeight: '300',
    }),
    placeholder: (provided) => ({
      ...provided,
      fontSize: '16px',
      fontWeight: '300',
    }),
    menuList: (provided) => ({
      ...provided,
      padding: 0,
    }),
    menuPortal: (base) => ({...base, zIndex: 9999}),
  };
}

/**
 * Shared dropdown indicator component for typeahead selects
 * Shows search icon when no value is selected, nothing when a value is selected
 */
export function TypeaheadDropdownIndicator<
  Option,
  IsMulti extends boolean = false,
  Group extends GroupBase<Option> = GroupBase<Option>,
>({
  selectProps,
}: DropdownIndicatorProps<Option, IsMulti, Group>): React.ReactElement {
  const hasValue = Array.isArray(selectProps.value)
    ? selectProps.value.length > 0
    : !!selectProps.value;
  return hasValue ? <></> : <SearchDropdownIndicator />;
}
